<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  placeholder="Key in allowance type here"
                  append-icon="search"
                  label="Search Allownace Type"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Allowance Type's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <payroll-setup-allowance-penalty-types-dialog-create
                  @created="loadAllowancePenaltyTypes"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredAllowancePenaltyTypes"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.rate="{ item }">
              <div>
                <span>
                  {{ item.rate / 100 }}
                </span>
              </div>
            </template>
            <template v-slot:item.unit_of_measurement_id="{ item }">
              <div>
                <span>
                  {{ item.unit_of_measurement_id }}
                </span>
              </div>
            </template>
            <template v-slot:item.is_negative="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_negative ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.is_epf_contribute="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_epf_contribute ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.is_eis_contribute="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_eis_contribute ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.is_socso_contribute="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_socso_contribute ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.is_pcb="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_pcb ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.is_fixed="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_fixed ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.is_additional_remuneration="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_additional_remuneration ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.is_hrdf="{ item }">
              <div>
                <v-icon medium>
                  {{ item.is_hrdf ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                </v-icon>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-card-actions>
                <span v-if="statusFilter">
                  <payroll-setup-allowance-penalty-types-dialog-edit 
                    :allowance-penalty-type="item"
                    @updated="refreshData"
                  />
                  <span class="mx-1" />
                  <payroll-setup-allowance-penalty-types-dialog-delete 
                    :allowance-penalty-type="item"
                    @deleted="refreshData"
                  />
                </span>
                <span v-else>
                  <payroll-setup-allowance-penalty-types-dialog-restore
                    :allowance-penalty-type="item"
                    @restored="refreshData"
                  />
                </span>
              </v-card-actions>
            </template> 
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollSetupAllowancePenaltyTypesDialogCreate: () => import('@/components/payroll/setup/allowancePenaltyTypes/DialogCreate'), 
      PayrollSetupAllowancePenaltyTypesDialogEdit: () => import('@/components/payroll/setup/allowancePenaltyTypes/DialogEdit'), 
      PayrollSetupAllowancePenaltyTypesDialogDelete: () => import('@/components/payroll/setup/allowancePenaltyTypes/DialogDelete'), 
      PayrollSetupAllowancePenaltyTypesDialogRestore: () => import('@/components/payroll/setup/allowancePenaltyTypes/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Allowance Types',
      }
    },
    data () {
      return {
        allowancePenaltyTypes: [],
        trashedAllowancePenaltyTypes: [],
        headers: [
          {
            text: 'Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Rate',
            align: 'left',
            value: 'rate',
          },
          {
            text: 'Unit',
            align: 'left',
            value: 'unit_of_measurement.name',
          },
          {
            text: 'Negative?',
            align: 'center',
            value: 'is_negative',
          },
          {
            text: 'EPF?',
            align: 'center',
            value: 'is_epf_contribute',
          },
          {
            text: 'EIS?',
            align: 'center',
            value: 'is_eis_contribute',
          },
          {
            text: 'SOCSO?',
            align: 'center',
            value: 'is_socso_contribute',
          },
          {
            text: 'Taxable?',
            align: 'center',
            value: 'is_pcb',
          },
          {
            text: 'Additional Remuneration?',
            align: 'center',
            value: 'is_additional_remuneration',
          },
          {
            text: 'Fixed?',
            align: 'center',
            value: 'is_fixed',
          },
          {
            text: 'Hrdf?',
            align: 'center',
            value: 'is_hrdf',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredAllowancePenaltyTypes () {
        return this.statusFilter ? this.allowancePenaltyTypes : this.trashedAllowancePenaltyTypes
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadAllowancePenaltyTypes () {
        this.$api.allowancePenaltyTypes().list('')
          .then(response => {
            this.allowancePenaltyTypes = response.data
            this.tableLoading = false
          })
      },
      loadTrashedAllowancePenaltyTypes () {
        this.$api.allowancePenaltyTypes().listTrashed()
          .then(response => {
            this.trashedAllowancePenaltyTypes = response.data
          })
      },
      refreshData () {
        this.loadAllowancePenaltyTypes()
        this.loadTrashedAllowancePenaltyTypes()
      },
    },
  }
</script>
